export const LOADING = {
    STARTED: "LOADING_STARTED",
    ENDED: "LOADING_ENDED",
    ERROR: {
        SHOW: "LOADING_ERROR_SHOW",
        HIDE: "LOADING_ERROR_HIDE",
    },
};
